import React from 'react';
import GenericFilter from './GenericFilter';

const HiringFilter = (props) => <GenericFilter {...props} titleKey={props.slug} namePrefix={props.slug} />;

export default HiringFilter;
